<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppLayout from './app/AppLayout.vue';
import { useAuthStore } from '@core/auth/auth.store';

const auth = useAuthStore();
const route = useRoute();

// Login-Seite ohne Layout-Rahmen; alles andere in der App-Shell.
const mitLayout = computed(() => auth.isLoggedIn && route.name !== 'login');
</script>

<template>
  <AppLayout v-if="mitLayout" />
  <router-view v-else />
</template>
